import "./siteWarning.css";
import React, { useState, useEffect } from "react";
import Constants from "../../helpers/Constants";
import apiService from "../../services/ApiService";

const SiteWarning = () => {
  const [buildNumber, setBuildNumber] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    apiService.get(Constants.ApiPath.BuildNumber).then((result) => {
      setBuildNumber(result.data);
      setIsLoading(false);
    });
  }, []);
  return !isLoading && buildNumber !== "" ? (
    <div className="d-flex justify-content-center fixed-bottom">
      <div className="test-site-warning">Test Site, Build: {buildNumber}</div>
    </div>
  ) : null;
};

export default SiteWarning;
